export default __webpack_public_path__ + "static/media/PurpleEllipse.ff7100d4.svg";